export type CnAccount = {
  id: string;
  email?: string;
  username?: string;
  createdAt?: string;
};

export type CnMoney = {
  amount: number;
  currency: string;
};

export type CnInventoryLine = {
  id: string;
  customId: string | null;
  productId: number;
  game: string;
  finish: string;
  condition: string | null;
  language: string | null;
  quantity: number;
  forSale: boolean;
  listing: { price: CnMoney } | null;
  updatedAt?: string;
  // Present on search/export payloads when expanded
  name?: string;
  printNumber?: string;
  expansion?: string;
  setCode?: string;
};

export type CnProductSearchHit = {
  id: number;
  name: string;
  printNumber?: string | null;
  game?: string;
  imageUrl?: string | null;
  expansion?: { id?: number; name?: string; code?: string } | null;
  finishes?: string[];
  /** Présent sur les résultats de POST /products/search */
  pricesByFinish?: Record<string, CnFinishPrices> | null;
};

export type CnListSummary = {
  id: string;
  name: string;
  game: string;
  status: "forSale" | "toComplete" | "hold";
  description: string | null;
  bannerUrl: string | null;
  completionPercentage: number;
  itemCount: number;
  totalQuantity: number;
  updatedAt?: string;
};

export type CnListItem = {
  id: string;
  productId: number;
  name: string;
  nameSlug?: string;
  expansion: string | null;
  finish: string;
  quantity: number;
  quantityFulfilled: number;
};

export type CnList = CnListSummary & { items: CnListItem[] };

export type CnCardnexusPrice = {
  low?: CnMoney | number;
  listingCount?: number;
  availableQuantity?: number;
};

export type CnFinishPrices = {
  cardmarket?: {
    currency: string;
    low?: number;
    mid?: number;
    high?: number;
    marketValue?: number;
  };
  tcgplayer?: {
    currency: string;
    low?: number;
    mid?: number;
    high?: number;
    marketValue?: number;
  };
  cardnexus?: CnCardnexusPrice;
};

export type CnProductPrices = {
  productId: number;
  pricesByFinish: Record<string, CnFinishPrices>;
};

export type CnErrorBody = {
  code?: string;
  status?: number;
  message?: string;
  data?: unknown;
};

export class CardNexusError extends Error {
  status: number;
  code: string;
  data: unknown;

  constructor(status: number, body: CnErrorBody | string) {
    if (typeof body === "string") {
      super(body);
      this.code = "UNKNOWN";
      this.data = null;
    } else {
      super(body.message || `CardNexus error ${status}`);
      this.code = body.code || "UNKNOWN";
      this.data = body.data ?? null;
    }
    this.status = status;
    this.name = "CardNexusError";
  }
}
